import React from 'react'
import { Header, PageHeaderBackIcon } from '@lightspeed/design-system-react'
import { reactular } from '@vendhq/reactular'
import { useT } from '@transifex/react'
import { STATES } from '../../../../../lib/routes'
import { $state } from '../../../ng-compat/imports'

interface Props {
  isQuote?: boolean
  hasServiceOrder?: boolean
}

export const BackToSaleHeader: React.FC<Props> = ({ isQuote = false }) => {
  const t = useT()
  const labels = {
    isQuote: t('Quote', { _context: 'Payment screen header for regular sale' }),
    default: t('Sale', {
      _context: 'Payment screen header for quote created sale',
    }),
  }
  const getLabel = () => {
    if (isQuote) {
      return labels.isQuote
    } else {
      return labels.default
    }
  }

  return (
    <Header type="hero" level="1" className="vs-page-header">
      {$state.current.name !== STATES.SALE_CONFIRMATION && (
        <PageHeaderBackIcon
          href="/webregister/"
          onClick={() => $state.go(STATES.SALE)}
        />
      )}
      {getLabel()}
    </Header>
  )
}

export const BackToSaleHeaderComponent = reactular(
  BackToSaleHeader,
  ['isQuote', 'hasServiceOrder'],
  'reactWrapper'
)
